import apiClient from './apiClient';

export const getBets = (params) => apiClient.get('/bet_order', { params });